export default "__VITE_ASSET__Con2hNJR__"